import { styled } from '@mui/material/styles';
import { SIDE_NAV_WIDTH } from '@utils/sideNavHelpers';

export const AppDiv = styled('main')({
  display: 'flex',
  minHeight: '100vh',
});

export const MainContent = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  marginLeft: SIDE_NAV_WIDTH,
  minWidth: `calc(100% - ${SIDE_NAV_WIDTH})`,
  flex: 1,
  fontFamily: 'Roboto, sans-serif',
  padding: theme.spacing(4, 6),
  [theme.breakpoints.down('md')]: {
    marginLeft: 0,
    minWidth: '100%',
    padding: theme.spacing(10, 2, 4),
  },
}));
